import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  makeStyles, Typography, Box, Modal, Button, Snackbar, Accordion, AccordionDetails, Grid, InputLabel, Select, MenuItem, FormControl
} from '@material-ui/core';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import { useEffectAsync } from '../reactHelper';

import { api_call, console_log, empty } from '../helpers/untils';
import { DEVICE_TYPE } from '../config/constant';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '420px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
};
const useStyles = makeStyles(() => ({
  details: {
    flexDirection: 'column',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > *': {
      flexBasis: '33%',
    },
  },
  formContainer: {
    display: 'block',
    width: '100%',
  },
  formRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  commandLabelBlock: {
    flex: 1,
  },
  inputRadioBlock: {
    flex: 1,
  },
  inputRadio2Block: {
    flex: 2,
  },
}));

const commandTypeList = [
  {
    label: 'Unlock',
    value: 'Unlock'
  },
  {
    label: 'Lock',
    value: 'Lock'
  },
  {
    label: 'Horn',
    value: 'Horn'
  },
  {
    label: 'Unkill',
    value: 'Unkill'
  },
  {
    label: 'Kill',
    value: 'Kill'
  },
  {
    label: 'Location',
    value: 'Location'
  },
]

const MoovetraxDeviceForm = (props) => {
  const { item, setItem, setSnackbarOpen, setToastMessage } = props;
  const user = useSelector((state) => state.session.user);

  const classes = useStyles();
  const [apiLoading, setApiLoading] = useState(false)
  const [slaveId, setSlaveId] = useState(0)

  // Devices owned by the current user (with a valid uniqueId), fetched from the
  // API so the list includes every owned device, not just the ones held in redux.
  // The current/master device itself is excluded. One is chosen as the slave.
  const [slaveOptions, setSlaveOptions] = useState([])

  useEffectAsync(async () => {
    const url = `/api/devices/get-user-devices-for-slave?masterId=${item?.id}&slaveId=${item?.slaveId}`;
    const response = await api_call(url)
    if (response.ok) {
      const apiData = await response.json()
      const list = (apiData.devices || []).filter((device) => device.id !== item?.id)
      setSlaveOptions(list)
      // Preselect the saved slave only if it is present in the list; otherwise
      // fall back to the "No Device Choosen" empty option.
      const savedSlaveId = item?.slaveId || 0
      const exists = list.some((device) => device.id === savedSlaveId)
      setSlaveId(exists ? savedSlaveId : 0)
    }
  }, [item]);

  const handleSubmitDevice = async () => {
    const url = `/api/devices/submitAdditionMoovetraxDevice`;
    const payload = {
      user_id: user.id,
      masterId: item.id,
      slaveId: slaveId || 0,
    }

    setApiLoading(true)
    let response = await api_call(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    setApiLoading(false)
    if (response.ok) {
      const apiData = await response.json()
      setItem(apiData['device'])

      setToastMessage(apiData['message']);
      setSnackbarOpen(true);
    } else {
      const apiError = response
      console_log("apiError:::", apiError)
      setToastMessage(apiError.error);
      setSnackbarOpen(true);
    }
  }

  return (
    <>
      <Accordion defaultExpanded>
        <>
          <AccordionDetails className={classes.details}>
            <Grid item style={{ width: '100%', paddingTop: '8px' }}>
              <FormControl margin="normal" variant="filled" fullWidth>
                <InputLabel>Device</InputLabel>
                <Select
                  value={slaveId}
                  onChange={(event) => setSlaveId(event.target.value)}
                >
                  <MenuItem value={0}>No Device Choosen</MenuItem>
                  {slaveOptions.map((device) => (
                    <MenuItem key={device.id} value={device.id}>
                      {`${device.name || 'Device'} (${device.uniqueId})`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <div className={classes.buttons} style={{ paddingTop: '15px', width: '100%', margin: 'auto' }}>
              <Button type="button" color="primary" variant="contained" onClick={() => handleSubmitDevice()} disabled={apiLoading}>
                Submit
              </Button>
            </div>
          </AccordionDetails>
        </>
      </Accordion>
    </>
  );
}

const MoovetraxDeviceControlForm = (props) => {
  const { item, setItem, setOpen, setSnackbarOpen, setToastMessage } = props;
  const user = useSelector((state) => state.session.user);

  const classes = useStyles();
  useEffect(() => {
    if (!empty(item) && !empty(item.commandSetting)) {
      const setting = JSON.parse(item.commandSetting)
      setCommandSetting(setting)
    } else {
      initCommandSetting();
    }
  }, [item]);

  const [apiLoading, setApiLoading] = useState(false)

  const [commandSetting, setCommandSetting] = useState(null);
  const initCommandSetting = () => {
    let setting = {}
    for (let k in commandTypeList) {
      const commandTypeItem = commandTypeList[k]
      const commandType = commandTypeItem['value']
      if (commandType === 'Unlock' || commandType === 'Lock' || commandType === 'Location') {
        setting[commandType] = DEVICE_TYPE.SMARTCAR
      } else {
        setting[commandType] = DEVICE_TYPE.MOOVETRAX
      }
    }
    setCommandSetting(setting)
  }
  const onChangeCommandSetting = (commandType, event) => {
    const setting = { ...commandSetting }
    setting[commandType] = event.target.value
    setCommandSetting(setting)
  }

  const handleSaveSetting = async () => {
    if (empty(item.slaveId)) {
      setToastMessage(`Please submit Moovetrax device first`);
      setSnackbarOpen(true);
      return false;
    }
    const url = `/api/devices/saveAdditionMoovetraxControlSetting`;
    const payload = {
      user_id: user.id,
      device_id: item.id,
      commandSetting: JSON.stringify(commandSetting),
    }

    setApiLoading(true)
    let response = await api_call(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    setApiLoading(false)
    if (response.ok) {
      const apiData = await response.json()
      setItem(apiData['device'])

      setToastMessage(`Moovetrax device has been saved successfully`);
      setSnackbarOpen(true);
    } else {
      const apiError = response
      console_log("apiError:::", apiError)
      setToastMessage(apiError.error);
      setSnackbarOpen(true);
    }

  }

  return (
    <>
      <Accordion defaultExpanded>
        <>
          <AccordionDetails className={classes.details}>
            <div className={classes.formContainer}>
              <div className={classes.formRow}>
                <div className={classes.commandLabelBlock}>
                  <label></label>
                </div>
                <div className={classes.inputRadioBlock}>
                  <label>Built In</label>
                </div>
                <div className={classes.inputRadioBlock}>
                  <label>Moovetrax</label>
                </div>
              </div>

              {
                (commandSetting !== null) && (commandTypeList.map((itemType, index) => {
                  return (
                    <div className={classes.formRow} key={index}>
                      <div className={classes.commandLabelBlock}>
                        <label>{itemType.label}</label>
                      </div>
                      <div className={classes.inputRadio2Block}>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={commandSetting[itemType.value]}
                          onChange={(event) => onChangeCommandSetting(itemType.value, event)}
                          style={{ justifyContent: "flex-start", flex: 1 }}
                          row
                        >
                          <div className={classes.inputRadioBlock}>
                            <FormControlLabel value={DEVICE_TYPE.SMARTCAR} control={<Radio />} label="" />
                          </div>
                          <div className={classes.inputRadioBlock}>
                            <FormControlLabel value={DEVICE_TYPE.MOOVETRAX} control={<Radio />} label="" />
                          </div>
                        </RadioGroup>
                      </div>
                    </div>
                  )
                }))
              }
            </div>
            <div className={classes.buttons} style={{ paddingTop: '15px', width: '100%', margin: 'auto' }}>
              <Button type="button" color="primary" variant="contained" onClick={() => handleSaveSetting()} disabled={apiLoading}>
                Save
              </Button>
              <Button type="button" color="primary" variant="outlined" onClick={() => setOpen(false)}>
                Close
              </Button>
            </div>

          </AccordionDetails>
        </>
      </Accordion>
    </>
  );
}

const AdditionMoovetraxModal = (props) => {
  const { open, setOpen, item, setItem } = props;

  const handleModalClose = () => {
    setOpen(false)
  }
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  return (
    <>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={modalStyle}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarOpen}
            onClose={() => { setSnackbarOpen(false) }}
            autoHideDuration={1500}
            message={toastMessage}
          />
          <Typography>Add Moovetrax device</Typography>

          <div className='mt-3'>
            <MoovetraxDeviceForm
              item={item}
              setItem={setItem}
              setOpen={setOpen}
              setSnackbarOpen={setSnackbarOpen}
              setToastMessage={setToastMessage}
            />
          </div>
          <div className='mt-5'>
            <MoovetraxDeviceControlForm
              item={item}
              setItem={setItem}
              setOpen={setOpen}
              setSnackbarOpen={setSnackbarOpen}
              setToastMessage={setToastMessage}
            />
          </div>

        </Box>
      </Modal>
    </>
  );
};

export default AdditionMoovetraxModal;
